export enum CommentCodesTransferStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
}

export interface CommentCodesTransferModel {
  id: number;
  jobId: string;
  status: string;
  startedAt: string;
  finishedAt: string;
  createdAt: string;
  updatedAt: string;
}
